
import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './customTextEditor.scss'
import CustomQuillToolbar, { modules, formats } from './customQuillToolbar';

export const CustomTextEditor = (props) => {
    return (
        <div>
             <CustomQuillToolbar />
                <ReactQuill
                    theme="snow"
                    id="shared_customTextEditor_textEditorTextAreaId"
                    value={props.value}
                    onChange={props.handleOnChange}
                    modules={modules}
                    formats={formats}
             />
        </div>
    )
}